export default "__VITE_ASSET__DsuCcAFM__"